const STATUS_MESSAGES = {
  403: "You can't make this change.",
  404: "This item no longer exists.",
  429: "Too many attempts. Please wait a moment and try again.",
};

const GENERIC_MESSAGE = "Something went wrong. Please try again.";

// DRF sends messages as strings, lists ({"message": ["..."]}) or per field
// ({"old_slot_id": ["..."]}); this returns the first readable one
const firstText = (value) => {
  if (typeof value === "string") {
    return value;
  }
  if (Array.isArray(value)) {
    for (const item of value) {
      const text = firstText(item);
      if (text) return text;
    }
  }
  if (value && typeof value === "object") {
    for (const key of ["message", "detail", "non_field_errors"]) {
      const text = firstText(value[key]);
      if (text) return text;
    }
    for (const item of Object.values(value)) {
      const text = firstText(item);
      if (text) return text;
    }
  }
  return undefined;
};

export const getErrorMessage = (error) => {
  // Hooks pass their error state, which is empty when nothing failed
  if (!error) {
    return undefined;
  }
  if (typeof error === "string") {
    return error;
  }

  const response = error?.response;
  if (!response) {
    // No answer from the server: offline, timed out or blocked
    if (error?.code === "ECONNABORTED") {
      return "The server took too long to answer. Please try again.";
    }
    if (error?.isAxiosError || error?.message === "Network Error") {
      return "Can't reach the server. Check your connection and try again.";
    }
    return error?.message || GENERIC_MESSAGE;
  }

  // An HTML error page is not a message to show
  const data = typeof response.data === "string" ? undefined : response.data;
  return (
    firstText(data) ||
    STATUS_MESSAGES[response.status] ||
    (response.status >= 500
      ? "Something went wrong on our side. Please try again later."
      : GENERIC_MESSAGE)
  );
};
